<div class="PageTitle">
    <h3 style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
        Perf Measurements</h3>
</div>
<hr>

<div class="row">
    <div class="col-md-12">
        <mat-card *ngIf="writeMode">
            <mat-card-title>
                <div class="PageTitle">
                    <h4
                        style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
                        {{perfMeasurementsFieldTitle}}</h4>
                </div>
            </mat-card-title>
            <!-- content for add -->
            <mat-card-content>

                <br>

                <!-- <div class="row" *ngIf="showModifyPerfmeasurementsButton">
                    <label style="padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
                        <h4>Perf Measurement ID: {{perfMeasurementId}}</h4>
                    </label>
                </div> -->

                <div class="row">
                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Recipe Number</mat-label>
                            <input [formControl]="recipeNumControl" matInput placeholder="Recipe Number" maxlength="10"
                                value="">
                            <mat-error>Invalid Recipe Number</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Number Of Perfs</mat-label>
                            <input [formControl]="noOfInsertsControl" matInput placeholder="Number Of Perfs"
                                maxlength="10" value="">
                            <mat-error>Invalid Number Of Perfs</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Horizontal Perf 1</mat-label>
                            <input [formControl]="horzPerf1Control" matInput placeholder="Horizontal Perf 1"
                                maxlength="10" value="">
                            <mat-error>Invalid Horizontal Perf 1</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Horizontal Perf 2</mat-label>
                            <input [formControl]="horzPerf2Control" matInput placeholder="Horizontal Perf 2"
                                maxlength="10" value="">
                            <mat-error>Invalid Horizontal Perf 2</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Horizontal Perf 3</mat-label>
                            <input [formControl]="horzPerf3Control" matInput placeholder="Horizontal Perf 3"
                                maxlength="10" value="">
                            <mat-error>Invalid Horizontal Perf 3</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Horizontal Perf 4</mat-label>
                            <input [formControl]="horzPerf4Control" matInput placeholder="Horizontal Perf 4"
                                maxlength="10" value="">
                            <mat-error>Invalid Horizontal Perf 4</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Vertical Perf 1</mat-label>
                            <input [formControl]="vertPerf1Control" matInput placeholder="Vertical Perf 1"
                                maxlength="10" value="">
                            <mat-error>Invalid Vertical Perf 1</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 200px; height:100px;">
                        <mat-form-field appearance="outline" class="w-100" style="width: 175px;">
                            <mat-label>Vertical Perf 2</mat-label>
                            <input [formControl]="vertPerf2Control" matInput placeholder="Vertical Perf 2"
                                maxlength="10" value="">
                            <mat-error>Invalid Vertical Perf 2</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-1" style="width: 300px; height:300px; max-width: 300px; max-height:150px;">
                        <mat-form-field appearance="outline" class="w-100"
                            style="width: 300px; height:300px; max-width: 300px; max-height: 150px;">
                            <mat-label>Comments</mat-label>
                            <textarea [formControl]="commentsControl" matInput placeholder="Comments"
                                style="width: 275px; height:125px; max-width: 275px; max-height: 125px;"></textarea>
                            <mat-error>Invalid Comments</mat-error>
                        </mat-form-field>
                    </div>



                </div>

                <br>

                <div class="row">
                    <!-- button row for submit new perf measurements -->
                    <div class="button-row col-md-2" style="padding-top: 10px;" *ngIf="showAddPerfmeasurementsButton">
                        <button class="mr-1" mat-flat-button color="primary" (click)="addPerfMeasurementsButton()"
                            [disabled]="addPerfMeasurementsDisable">Add</button>
                    </div>

                    <!-- button row for submitting a modify request -->
                    <div class="button-row col-md-2" style="padding-top: 10px;"
                        *ngIf="showModifyPerfmeasurementsButton">
                        <button class="mr-1" mat-flat-button color="primary" (click)="modifyPerfMeasurementsButton()"
                            [disabled]="modifyPerfMeasurementsDisable">Modify</button>
                    </div>

                    <!-- button row for switching to adding a new perf measurement -->
                    <div class="button-row col-md-2" style="padding-top: 10px;"
                        *ngIf="showAddNewPerfmeasurementsButton">
                        <button class="mr-1" mat-flat-button color="primary"
                            (click)="addNewPerfMeasurementButton()">Cancel</button>
                    </div>



                </div>

            </mat-card-content>
        </mat-card>

        <br>
        <br>

        <mat-card>
            <mat-card-title>
                <div class="PageTitle">
                    <h4
                        style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
                        Perf Measurements table</h4>
                    <h5
                        style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
                        Click on any row to modify Perf Measurements</h5>
                </div>
            </mat-card-title>



            <mat-card-content>

                <!-- button row for submit new perf measurements -->
                <div class="button-row" style="padding-top: 10px;">
                    <button class="mr-1" mat-flat-button color="primary" (click)="exportTableButton()">Export
                        Table</button>
                </div>

                <div class="table-container">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th>Recipe Number</th>
                                <th>Number of Perfs</th>
                                <th>Horizontal Perf 1</th>
                                <th>Horizontal Perf 2</th>
                                <th>Horizontal Perf 3</th>
                                <th>Horizontal Perf 4</th>
                                <th>Vertical Perf 1</th>
                                <th>Vertical Perf 2</th>
                                <th>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of tableData" (click)="onRowClick(item)" class="table-row">
                                <td>{{ item.recipeNum ?? '' }}</td>
                                <td>{{ item.noOfInserts ?? '' }}</td>
                                <td>{{ item.horzPerf1 ?? '' }}</td>
                                <td>{{ item.horzPerf2 ?? '' }}</td>
                                <td>{{ item.horzPerf3 ?? '' }}</td>
                                <td>{{ item.horzPerf4 ?? '' }}</td>
                                <td>{{ item.vertPerf1 ?? '' }}</td>
                                <td>{{ item.vertPerf2 ?? '' }}</td>
                                <td>{{ item.comments }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </mat-card-content>

        </mat-card>
    </div>
</div>